/*专家关注表*/
import request from '@/utils/request'

export function getPoliticsList(data) {
    return request({
        url: '/management/professorList',
        method: 'get',
        params: data
    })
}